import { render } from "./FrameWrapperSubsection.vue?vue&type=template&id=77d30f37&ts=true"
import script from "./FrameWrapperSubsection.vue?vue&type=script&lang=ts"
export * from "./FrameWrapperSubsection.vue?vue&type=script&lang=ts"

import "./FrameWrapperSubsection.vue?vue&type=style&index=0&id=77d30f37&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__